import styled from 'styled-components';

export const StyledLanding = styled.div`
  
`;